export const en = {
  additionalMembers: 'Add members',
  removeAddon: 'Remove',
  yourCurrentPlan: 'Your current plan',
  currentlyUsing: 'You are currently using',
  yearly: 'Yearly',
  premiumGuestFeatures: 'Premium Guest Features addon'
};
export type Translations = typeof en;
